import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppId } from '../../context/AppIdContext';
import Header from '../../component/header';
import WhatsappSlipButton from '../../component/WhatsappSlipButton';
import PracharButton from '../../component/PracharButton';
import '../../style/speakSearch.css';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const CampaignDetails = () => {
    const { appId, language, userId } = useAppId();
    const location = useLocation();
    const navigate = useNavigate();

    const campaignInfo = location.state?.campaign || {};
    const campaignId = campaignInfo?.campaign_id;

    const [voters, setVoters] = useState([]);
    const [loading, setLoading] = useState(true);

    const [isEditMobileOpen, setIsEditMobileOpen] = useState(false);
    const [editingVoter, setEditingVoter] = useState(null);
    const [newMobile, setNewMobile] = useState('');
    const [isSavingMobile, setIsSavingMobile] = useState(false);

    const lang = language || 'en';

    const t = {
        en: {
            title: "Campaign Details",
            loading: "Loading Voters Data...",
            noData: "No voters found for this campaign.",
            campId: "Campaign ID",
            totalSms: "Total SMS",
            totalCost: "Total Cost",
            totalLogs: "Total Logs",
            createdBy: "Created By",
            remarks: "Remarks",
            date: "Date",
            voterListTitle: "Voter List",
            partNo: "Part No",
            serialNo: "Serial No",
            idCard: "ID Card",
            mobile: "Mobile",
            address: "Address",
            genderAge: "Gender/Age",
            call: "Call",
            text: "Text",
            slip: "Slip",
            prachar: "Prachar",
            print: "Print",
            family: "Family",
            mobileNotAvailable: "Mobile number is not available for this voter.",
            fatherHusband: "F/S",
            idCardNo: "ID Card No",
            boothNo: "Booth No",
            houseNo: "House No",
            pollingLoc: "Voting Loc",
            addToGroup: "Add to Group",
            locality: "Locality",
            addToGroupConfirm: "Are you sure you want to ADD this member to your group?",
            addToGroupSuccess: "Added to group successfully!",
            addToGroupFailed: "Failed to add to group.",
            addToGroupError: "An error occurred while adding to the group.",
            editMobileTitle: "Update Mobile Number",
            mobilePlaceholder: "Enter 10-digit mobile number",
            mobileErrorLength: "Mobile number must be 10 digits",
            mobileErrorStart: "Number must start with 6, 7, 8, or 9",
            cancel: "Cancel",
            save: "Save",
            saving: "Saving...",
            mobileUpdateSuccess: "Mobile number updated successfully!",
            mobileUpdateFailed: "Failed to update mobile number.",
            mobileUpdateError: "An error occurred while updating the mobile number.",
            addressNotAvailable: "Address not available!"
        },
        hi: {
            title: "कैंपेन विवरण",
            loading: "मतदाता डेटा लोड हो रहा है...",
            noData: "इस कैंपेन के लिए कोई मतदाता नहीं मिला।",
            campId: "कैंपेन आईडी",
            totalSms: "कुल SMS",
            totalCost: "कुल खर्च",
            totalLogs: "कुल लॉग्स",
            createdBy: "द्वारा बनाया गया",
            remarks: "टिप्पणी",
            date: "दिनांक",
            voterListTitle: "मतदाता सूची",
            partNo: "भाग क्र.",
            serialNo: "सीरियल क्र.",
            idCard: "आईडी कार्ड",
            mobile: "मोबाइल",
            address: "पता",
            genderAge: "लिंग/आयु",
            call: "कॉल",
            text: "मैसेज",
            slip: "पर्ची",
            prachar: "प्रचार",
            print: "प्रिंट",
            family: "परिवार",
            mobileNotAvailable: "इस मतदाता के लिए मोबाइल नंबर उपलब्ध नहीं है।",
            fatherHusband: "पिता/पति",
            idCardNo: "पहचान पत्र नं.",
            boothNo: "बूथ नं",
            houseNo: "घर नं",
            pollingLoc: "मतदान स्थान",
            addToGroup: "ग्रूप में जोड़ें",
            locality: "स्थान",
            addToGroupConfirm: "क्या आप वाकई इस सदस्य को अपने ग्रूप में जोड़ना चाहते हैं?",
            addToGroupSuccess: "ग्रूप में सफलतापूर्वक जोड़ा गया!",
            addToGroupFailed: "ग्रूप में जोड़ने में विफल।",
            addToGroupError: "ग्रूप में जोड़ते समय एक त्रुटि हुई।",
            editMobileTitle: "मोबाइल नंबर अपडेट करें",
            mobilePlaceholder: "10 अंकों का मोबाइल नंबर दर्ज करें",
            mobileErrorLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileErrorStart: "नंबर 6, 7, 8, या 9 से शुरू होना चाहिए",
            cancel: "रद्द करें",
            save: "सेव करें",
            saving: "सेव हो रहा है...",
            mobileUpdateSuccess: "मोबाइल नंबर सफलतापूर्वक अपडेट हो गया!",
            mobileUpdateFailed: "मोबाइल नंबर अपडेट करने में विफल।",
            mobileUpdateError: "मोबाइल नंबर अपडेट करते समय एक त्रुटि हुई।",
            addressNotAvailable: "पता उपलब्ध नहीं है!"
        },
        gu: {
            title: "કેમ્પેઇન વિગતો",
            loading: "મતદાર માહિતી લોડ થઈ રહી છે...",
            noData: "આ કેમ્પેઇન માટે કોઈ મતદાર મળ્યા નથી.",
            campId: "કેમ્પેઇન આઈડી",
            totalSms: "કુલ SMS",
            totalCost: "કુલ ખર્ચ",
            totalLogs: "કુલ લોગ્સ",
            createdBy: "બનાવનાર",
            remarks: "વિગત",
            date: "તારીખ",
            voterListTitle: "મતદાર યાદી",
            partNo: "ભાગ નં.",
            serialNo: "ક્રમ નં.",
            idCard: "આઈડિકાર્ડ",
            mobile: "મોબાઇલ",
            address: "સરનામું",
            genderAge: "જાતિ/ઉમર",
            call: "કૉલ",
            text: "સંદેશ",
            slip: "સ્લિપ",
            prachar: "પ્રચાર",
            print: "પ્રિન્ટ",
            family: "કુટુંબ",
            mobileNotAvailable: "આ મતદાર માટે મોબાઇલ નંબર ઉપલબ્ધ નથી.",
            fatherHusband: "પિતા/પતિ",
            idCardNo: "ઓળખ કાર્ડ નં",
            boothNo: "બૂથ નં",
            houseNo: "ઘર નં",
            pollingLoc: "મતદાન સ્થળ",
            addToGroup: "જૂથમાં ઉમેરો",
            locality: "સ્થળ",
            addToGroupConfirm: "શું તમે ખરેખર આ સભ્યને તમારા જૂથમાં ઉમેરવા માંગો છો?",
            addToGroupSuccess: "જૂથમાં સફળતાપૂર્વક ઉમેરાયું!",
            addToGroupFailed: "જૂથમાં ઉમેરવામાં નિષ્ફળ.",
            addToGroupError: "જૂથમાં ઉમેરતી વખતે એક ભૂલ આવી.",
            editMobileTitle: "મોબાઇલ નંબર અપડેટ કરો",
            mobilePlaceholder: "10 અંકોનો મોબાઇલ નંબર દાખલ કરો",
            mobileErrorLength: "મોબાઇલ નંબર 10 અંકોનો હોવો જોઈએ",
            mobileErrorStart: "નંબર 6, 7, 8, અથવા 9 થી શરૂ થવો જોઈએ",
            cancel: "રદ કરો",
            save: "સેવ કરો",
            saving: "સેવ થઈ રહ્યું છે...",
            mobileUpdateSuccess: "મોબાઇલ નંબર સફળતાપૂર્વક અપડેટ થયો!",
            mobileUpdateFailed: "મોબાઇલ નંબર અપડેટ કરવામાં નિષ્ફળ.",
            mobileUpdateError: "મોબાઇલ નંબર અપડેટ કરતી વખતે એક ભૂલ આવી.",
            addressNotAvailable: "સરનામું ઉપલબ્ધ નથી!"
        }
    };

    const txt = t[lang] || t.en;

    useEffect(() => {
        if (!appId || !campaignId) {
            navigate('/campaigns');
            return;
        }

        const fetchCampaignVoters = async () => {
            setLoading(true);
            try {
                const response = await axios.post(`${BASE_URL}/api/dis_meta_bulk_campaign_wise_voter_list`, {
                    app_id: appId,
                    campaign_id: campaignId,
                    user_id: userId || "1"
                });

                if (response.data.success && response.data.data && response.data.data.result) {
                    setVoters(response.data.data.result);
                } else {
                    setVoters([]);
                }
            } catch (error) {
                console.error("Error fetching campaign voters:", error);
                setVoters([]);
            } finally {
                setLoading(false);
            }
        };

        fetchCampaignVoters();
    }, [appId, campaignId, userId, navigate]);

    const handleUpdateMobile = async () => {
        if (!newMobile || newMobile.length !== 10) {
            alert(txt.mobileErrorLength);
            return;
        }

        setIsSavingMobile(true);
        try {
            const payload = {
                app_id: appId?.toString(),
                voter_id: editingVoter.idcard_no,
                mobile_no: newMobile,
                modify_by: userId?.toString() || "1"
            };

            const response = await axios.post(`${BASE_URL}/api/upd_voter_mobile`, payload);

            if (response.data.success || response.data.Success === "1") {
                alert(txt.mobileUpdateSuccess);
                setVoters(prev => prev.map(v =>
                    v.id === editingVoter.id ? { ...v, contact_no: newMobile } : v
                ));
                setIsEditMobileOpen(false);
            } else {
                alert(txt.mobileUpdateFailed);
            }
        } catch (error) {
            console.error("Error updating mobile:", error);
            alert(txt.mobileUpdateError);
        } finally {
            setIsSavingMobile(false);
        }
    };

    const handleAddToGroup = async (voter) => {
        const isConfirmed = window.confirm(txt.addToGroupConfirm);
        if (!isConfirmed) return;

        try {
            const payload = {
                app_id: appId?.toString(),
                user_id: userId?.toString() || appId?.toString(),
                idcard: voter.idcard_no
            };

            const response = await axios.post(`${BASE_URL}/api/ins_my_group`, payload);

            if (response.data.success) {
                alert(txt.addToGroupSuccess);
            } else {
                alert(txt.addToGroupFailed);
            }
        } catch (error) {
            console.error("Error adding to group:", error);
            alert(txt.addToGroupError);
        }
    };

    const handleSmsShare = async (voter) => {
        if (!voter.contact_no) {
            alert(txt.mobileNotAvailable);
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_sms`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('સ્રી', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');
                window.location.href = `sms:${mobile}?body=${encodedMessage}`;

            } else {
                alert("Could not fetch family details for SMS.");
            }
        } catch (error) {
            console.error("Error generating SMS slip:", error);
            alert("Error generating SMS message.");
        }
    };

    const mobileValid = /^[6-9]\d{9}$/.test(newMobile);

    return (
        <div className="campaign-details-wrapper">
            <Header title={txt.title} />

            {/* ================= EDIT MOBILE MODAL ================= */}
            {isEditMobileOpen && (
                <div className="modal-overlay" onClick={() => setIsEditMobileOpen(false)}>
                    <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-icon-wrap">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                            </svg>
                        </div>
                        <h4 className="modal-title">{txt.editMobileTitle}</h4>
                        <p className="modal-subtitle">
                            {editingVoter?.eng_f_name || editingVoter?.f_name} {editingVoter?.eng_surname || editingVoter?.surname}
                        </p>

                        <div className="modal-input-wrap">
                            <input
                                type="tel"
                                maxLength="10"
                                value={newMobile}
                                onChange={(e) => setNewMobile(e.target.value.replace(/[^0-9]/g, ''))}
                                className={`modal-input ${newMobile.length === 10 && !mobileValid ? 'input-error' : ''}`}
                                placeholder={txt.mobilePlaceholder}
                                autoFocus
                            />
                            {newMobile.length > 0 && !mobileValid && (
                                <div className="modal-error-text">
                                    {newMobile.length < 10 ? txt.mobileErrorLength : txt.mobileErrorStart}
                                </div>
                            )}
                        </div>

                        <div className="modal-actions">
                            <button className="btn-cancel" onClick={() => setIsEditMobileOpen(false)}>
                                {txt.cancel}
                            </button>
                            <button
                                className="btn-save"
                                onClick={handleUpdateMobile}
                                disabled={isSavingMobile || !mobileValid}
                            >
                                {isSavingMobile ? txt.saving : txt.save}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className="details-container">

                {/* ================= PREMIUM SUMMARY CARD ================= */}
                <div className="premium-summary-card mb-4 slide-up-element">
                    <div className="summary-header">
                        <div className="summary-header-pattern"></div>
                        <div className="summary-header-pattern pattern-2"></div>
                        <div className="summary-header-shine"></div>
                        <div className="camp-badge-icon">
                            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                            </svg>
                        </div>
                        <div className="header-info">
                            <span className="summary-label">{txt.campId}</span>
                            <h2 className="summary-title">{campaignId || "N/A"}</h2>
                        </div>
                    </div>

                    <div className="summary-grid">
                        <div className="grid-item">
                            <div className="g-icon sms-icon-bg">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" /></svg>
                            </div>
                            <div className="g-details">
                                <span className="g-label">{txt.totalSms}</span>
                                <span className="g-value">{campaignInfo?.total_message_use || 0}</span>
                            </div>
                        </div>
                        <div className="grid-item">
                            <div className="g-icon cost-icon-bg">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.64-2.25 1.64-1.74 0-2.33-.89-2.46-1.87H7.76c.15 1.78 1.48 2.82 3.14 3.14V19h1.86v-1.7c1.61-.31 2.84-1.39 2.84-2.96 0-2.3-1.89-2.9-3.29-3.2z" /></svg>
                            </div>
                            <div className="g-details">
                                <span className="g-label">{txt.totalCost}</span>
                                <span className="g-value cost-color">₹{Number(campaignInfo?.total_cost || 0).toFixed(2)}</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ================= VOTER LIST SECTION ================= */}
                <div className="voter-list-header mb-3">
                    <h4 className="voter-list-heading">
                        <span className="heading-accent"></span>
                        {txt.voterListTitle}
                        <span className="badge-count">{voters.length}</span>
                    </h4>
                </div>

                {loading ? (
                    <div className="loader-wrapper mt-5">
                        <div className="spinner"></div>
                        <p className="loader-text">{txt.loading}</p>
                    </div>
                ) : voters.length === 0 ? (
                    <div className="empty-state mt-5">
                        <div className="empty-icon-wrap">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#8C95A1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                        </div>
                        <p>{txt.noData}</p>
                    </div>
                ) : (
                    <div className="row g-4">
                        {voters.map((voter, index) => (
                            <div className="col-12 col-md-6 col-lg-4" key={voter.id || index}>
                                <div className="voter-card-clean h-100">
                                    {/* Name Header */}
                                    <div className="voter-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div>
                                            <span className="serial-number">{index + 1}.</span>
                                            <span className="voter-name-bold ms-2">{voter.f_name} {voter.surname}</span>
                                        </div>
                                    </div>

                                    {/* Details Body */}
                                    <div className="voter-body position-relative">
                                        <div
                                            className="map-icon-wrapper"
                                            style={{ cursor: 'pointer', zIndex: 10 }}
                                            title="View on Google Maps"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                const address = voter.eng_localityid;
                                                if (address && address !== "N/A") {
                                                    window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`, '_blank');
                                                } else {
                                                    alert(txt.addressNotAvailable);
                                                }
                                            }}
                                        >
                                            <img src="https://upload.wikimedia.org/wikipedia/commons/a/aa/Google_Maps_icon_%282020%29.svg" alt="Map" width="15" />
                                        </div>
                                        <div className="info-row"><span className="label">{txt.fatherHusband}</span><span className="value">{voter.m_name || "N/A"}</span></div>
                                        <div className="info-row"><span className="label">{txt.address}</span><span className="value">{voter.eng_localityid || "N/A"}</span></div>
                                        <div className="info-row"><span className="label">{txt.serialNo}</span><span className="value">{voter.slnoinpart}</span></div>
                                        <div className="info-row" style={{ display: 'flex', alignItems: 'center' }}>
                                            <span className="label">{txt.mobile}</span>
                                            <span className="value mobile-value" style={{ flexGrow: 1 }}>{voter.contact_no || "N/A"}</span>
                                            <svg
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setEditingVoter(voter);
                                                    setNewMobile(voter.contact_no || '');
                                                    setIsEditMobileOpen(true);
                                                }}
                                                style={{ cursor: 'pointer', color: '#f59e0b', width: '18px', height: '18px', flexShrink: 0 }}
                                                fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                            </svg>
                                        </div>
                                        <div className="info-row"><span className="label">{txt.idCardNo}</span><span className="value">{voter.idcard_no || "N/A"}</span></div>
                                        <div className="info-row"><span className="label">{txt.boothNo}</span><span className="value">{voter.part_no || "N/A"}</span></div>
                                        <div className="info-row"><span className="label">{txt.houseNo}</span><span className="value">{voter.eng_house_no || "N/A"}</span></div>
                                        <div className="info-row"><span className="label">{txt.pollingLoc}</span><span className="value">{voter.eng_polling_location || "-"}</span></div>
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="voter-actions">
                                        <ActionButton icon="📞" color="#0ea5e9" label={txt.call}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (!voter.contact_no || voter.contact_no === "N/A" || voter.contact_no === "-" || voter.contact_no === "") {
                                                    alert(txt.mobileNotAvailable);
                                                } else {
                                                    window.open(`tel:${voter.contact_no}`, '_blank');
                                                }
                                            }}
                                        />
                                        <ActionButton icon="✉️" color="#f59e0b" label={txt.text} onClick={() => handleSmsShare(voter)} />
                                        <WhatsappSlipButton voter={voter} />
                                        <PracharButton voter={voter} />
                                        <ActionButton
                                            icon="🖨"
                                            color="#f97316"
                                            label={txt.print}
                                            onClick={() => navigate('/printer', { state: { voter_id: voter.id } })}
                                        />
                                        <ActionButton icon="👨‍👩‍👧" color="#fbbf24" label={txt.family} onClick={() => navigate('/dis_family_member', { state: { voter_id: voter.id } })} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <style jsx>{`
                .header-container-white {
                    background-color: #ffffff;
                    padding: 15px 32px;
                    border-bottom: 1px solid #e2e8f0;
                    margin: -24px 0px 10px 0px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.02);
                    position: sticky;
                    top: 0;
                    z-index: 10;
                }

                * {
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                }

                .campaign-details-wrapper {
                    width: 100%;
                    min-height: 100vh;
                    background:
                        radial-gradient(ellipse 80% 50% at 100% -10%, rgba(17, 129, 106, 0.08) 0%, transparent 55%),
                        radial-gradient(ellipse 60% 40% at 0% 100%, rgba(30, 58, 95, 0.06) 0%, transparent 50%),
                        #E6ECF5;
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
                    padding: 0;
                    margin: 0;
                    display: flex;
                    flex-direction: column;
                }

                .details-container {
                    width: 100%;
                    margin: 0 auto;
                    padding: 24px 32px 48px;
                    flex: 1;
                }

                @keyframes slideUp {
                    from { opacity: 0; transform: translateY(16px); }
                    to { opacity: 1; transform: translateY(0); }
                }

                .slide-up-element {
                    opacity: 0;
                    animation: slideUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
                }

                /* ============ MODAL ============ */
                .modal-overlay {
                    position: fixed; inset: 0;
                    background: rgba(15, 23, 42, 0.55);
                    backdrop-filter: blur(8px);
                    display: flex; align-items: center; justify-content: center;
                    z-index: 10000;
                    animation: fadeIn 0.2s ease;
                }
                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

                .modal-card {
                    background: #ffffff;
                    padding: 34px 30px 26px;
                    border-radius: 22px;
                    width: 90%;
                    max-width: 390px;
                    box-shadow: 0 28px 56px -16px rgba(15, 23, 42, 0.28);
                    animation: slideUp 0.35s cubic-bezier(0.16, 1, 0.3, 1);
                    text-align: center;
                    border: 1px solid #eef2f6;
                }

                .modal-icon-wrap {
                    width: 56px; height: 56px;
                    background: linear-gradient(145deg, #1a8f76, #11816A);
                    border-radius: 16px;
                    display: flex; align-items: center; justify-content: center;
                    margin: 0 auto 18px;
                    box-shadow: 0 10px 22px rgba(17, 129, 106, 0.35);
                }

                .modal-title { margin: 0 0 6px; font-size: 19px; color: #0f172a; font-weight: 800; letter-spacing: -0.3px; }
                .modal-subtitle { margin: 0 0 22px; font-size: 13px; color: #64748b; font-weight: 600; }

                .modal-input-wrap { text-align: left; margin-bottom: 26px; }

                .modal-input {
                    width: 100%; padding: 15px 16px;
                    border: 1.5px solid #e2e8f0; border-radius: 14px;
                    font-size: 15px; font-weight: 600; letter-spacing: 0.5px;
                    outline: none; box-sizing: border-box;
                    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
                    background: #f8fafc;
                }
                .modal-input:focus {
                    border-color: #11816A;
                    box-shadow: 0 0 0 4px rgba(17, 129, 106, 0.14);
                    background: #ffffff;
                }
                .modal-input.input-error {
                    border-color: #ef4444;
                    box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);
                }
                .modal-error-text { font-size: 11.5px; color: #ef4444; margin-top: 7px; font-weight: 600; }

                .modal-actions { display: flex; gap: 12px; }
                .btn-cancel {
                    flex: 1; padding: 13px 16px;
                    background: #f1f5f9; color: #475569;
                    border: none; border-radius: 14px;
                    cursor: pointer; font-weight: 700; font-size: 14px;
                    transition: background 0.2s;
                }
                .btn-cancel:hover { background: #e2e8f0; }
                .btn-save {
                    flex: 1; padding: 13px 16px;
                    background: linear-gradient(145deg, #1a8f76, #0f6f5b);
                    color: white; border: none; border-radius: 14px;
                    cursor: pointer; font-weight: 700; font-size: 14px;
                    box-shadow: 0 10px 20px rgba(17, 129, 106, 0.28);
                    transition: transform 0.15s, box-shadow 0.15s;
                }
                .btn-save:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 14px 24px rgba(17, 129, 106, 0.36); }
                .btn-save:disabled {
                    background: #cbd5e1; box-shadow: none; cursor: not-allowed;
                }

                /* ============ PREMIUM SUMMARY CARD ============ */
                .premium-summary-card {
                    background: #F9FBFC;
                    border-radius: 22px;
                    box-shadow: 0 12px 32px -12px rgba(15, 23, 42, 0.12), 0 2px 6px rgba(15, 23, 42, 0.04);
                    border: 1px solid rgba(232, 238, 244, 0.95);
                    overflow: hidden;
                }

                .summary-header {
                    position: relative;
                    display: flex;
                    align-items: center;
                    padding: 28px 30px;
                    background: linear-gradient(125deg, #0f2b3c 0%, #164a4a 42%, #11816A 100%);
                    overflow: hidden;
                }

                .summary-header-pattern {
                    position: absolute; top: -55%; right: -6%;
                    width: 260px; height: 260px;
                    background: radial-gradient(circle, rgba(255,255,255,0.12) 0%, transparent 70%);
                    border-radius: 50%;
                    pointer-events: none;
                }
                .summary-header-pattern.pattern-2 {
                    top: auto; bottom: -65%; left: 8%; right: auto;
                    width: 200px; height: 200px;
                    background: radial-gradient(circle, rgba(255,255,255,0.07) 0%, transparent 70%);
                }
                .summary-header-shine {
                    position: absolute;
                    inset: 0;
                    background: linear-gradient(105deg, transparent 40%, rgba(255,255,255,0.06) 50%, transparent 60%);
                    pointer-events: none;
                    animation: shineSweep 7s ease-in-out infinite;
                }
                @keyframes shineSweep {
                    0%, 100% { transform: translateX(-30%); opacity: 0; }
                    40% { opacity: 1; }
                    70% { transform: translateX(30%); opacity: 0; }
                }

                .camp-badge-icon {
                    width: 54px; height: 54px;
                    background: rgba(255,255,255,0.12);
                    backdrop-filter: blur(10px);
                    color: #ffffff;
                    border-radius: 16px;
                    display: flex; align-items: center; justify-content: center;
                    margin-right: 18px;
                    flex-shrink: 0;
                    border: 1px solid rgba(255,255,255,0.2);
                    box-shadow: inset 0 1px 0 rgba(255,255,255,0.12), 0 8px 16px rgba(0,0,0,0.12);
                    position: relative;
                    z-index: 1;
                }

                .header-info { flex-grow: 1; position: relative; z-index: 1; min-width: 0; }

                .summary-label {
                    font-size: 11px;
                    text-transform: uppercase;
                    letter-spacing: 1.3px;
                    color: rgba(255,255,255,0.62);
                    font-weight: 700;
                    display: block;
                    margin-bottom: 5px;
                }

                .summary-title {
                    font-size: 20px;
                    font-weight: 800;
                    color: #ffffff;
                    margin: 0;
                    letter-spacing: -0.2px;
                    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                }

                .status-badge {
                    background: rgba(255,255,255,0.12);
                    color: #d1fae5;
                    font-size: 12px;
                    font-weight: 700;
                    padding: 8px 14px;
                    border-radius: 999px;
                    border: 1px solid rgba(209, 250, 229, 0.28);
                    display: flex; align-items: center; gap: 7px;
                    position: relative; z-index: 1;
                    flex-shrink: 0;
                    backdrop-filter: blur(6px);
                }

                .status-dot {
                    width: 6px; height: 6px; border-radius: 50%;
                    background: #34d399;
                    box-shadow: 0 0 8px #34d399;
                    animation: pulse 1.6s ease-in-out infinite;
                }
                @keyframes pulse {
                    0%, 100% { opacity: 1; transform: scale(1); }
                    50% { opacity: 0.45; transform: scale(0.85); }
                }

                .summary-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 14px;
                    padding: 24px 26px;
                    background: #ffffff;
                }

                .grid-item {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 14px 12px;
                    border-radius: 16px;
                    background: #F9FBFC;
                    border: 1px solid #E8EEF4;
                    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
                }
                .grid-item:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.06);
                    border-color: #d7e8e3;
                }

                .g-icon {
                    width: 42px; height: 42px;
                    border-radius: 13px;
                    display: flex; align-items: center; justify-content: center;
                    flex-shrink: 0;
                }

                .sms-icon-bg { background: #E0EFEB; color: #11816A; }
                .cost-icon-bg { background: #FDECEC; color: #DC2626; }
                .log-icon-bg { background: #FEF3C7; color: #B45309; }
                .user-icon-bg { background: #E8EEF4; color: #1e3a5f; }

                .g-details { display: flex; flex-direction: column; min-width: 0; }
                .g-label { font-size: 10.5px; color: #8C95A1; font-weight: 700; text-transform: uppercase; letter-spacing: 0.4px; }
                .g-value { font-size: 17px; font-weight: 800; color: #1A1A1A; margin-top: 3px; letter-spacing: -0.2px; }
                .cost-color { color: #DC2626; }

                .summary-footer {
                    background: linear-gradient(180deg, #F9FBFC 0%, #F3F7FB 100%);
                    padding: 16px 26px;
                    border-top: 1px solid #E8EEF4;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 22px;
                }

                .footer-divider {
                    width: 1px; height: 28px; background: #E8EEF4;
                }

                .footer-line { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
                .f-label { color: #8C95A1; font-weight: 700; font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.5px; }
                .f-text { color: #334155; font-weight: 700; font-size: 13.5px; word-break: break-word; }

                /* ============ VOTER LIST HEADER ============ */
                .voter-list-header { display: flex; align-items: center; justify-content: space-between; margin-top: 10px; }

                .voter-list-heading {
                    font-size: 19px;
                    font-weight: 800;
                    color: #0f172a;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    margin: 0;
                    letter-spacing: -0.3px;
                }

                .heading-accent {
                    width: 4px; height: 20px;
                    background: linear-gradient(180deg, #11816A, #1e3a5f);
                    border-radius: 4px;
                    display: inline-block;
                }

                .badge-count {
                    background: #11816A;
                    color: white;
                    font-size: 12px;
                    padding: 4px 12px;
                    border-radius: 20px;
                    font-weight: 700;
                    box-shadow: 0 6px 14px rgba(17, 129, 106, 0.28);
                }

                /* ============ LOADER / EMPTY STATE ============ */
                .loader-wrapper { display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 50px 0; }
                .spinner {
                    width: 42px; height: 42px;
                    border: 4px solid #d1d5db;
                    border-top: 4px solid #11816A;
                    border-radius: 50%;
                    animation: spin 0.9s linear infinite;
                    margin-bottom: 14px;
                }
                @keyframes spin { to { transform: rotate(360deg); } }
                .loader-text { color: #6b7280; font-weight: 700; font-size: 14px; }

                .empty-state {
                    text-align: center; color: #64748b; font-weight: 600;
                    background: #F9FBFC;
                    border-radius: 20px;
                    padding: 52px 20px;
                    border: 1.5px dashed #d5dde8;
                }
                .empty-icon-wrap {
                    width: 66px; height: 66px;
                    background: #E8EEF4;
                    border-radius: 50%;
                    display: flex; align-items: center; justify-content: center;
                    margin: 0 auto 16px;
                }

                /* ============ RESPONSIVE ============ */
                @media (max-width: 992px) {
                    .summary-grid { grid-template-columns: repeat(2, 1fr); }
                    .details-container { padding: 18px 20px 32px; }
                }

                @media (max-width: 768px) {
                    .details-container { padding: 14px 16px 26px; }
                }

                @media (max-width: 576px) {
                    .summary-header { flex-wrap: wrap; gap: 12px; padding: 22px; }
                    .status-badge { margin-left: auto; }
                    .summary-grid { grid-template-columns: 1fr 1fr; padding: 16px; gap: 10px; }
                    .grid-item { padding: 12px 10px; }
                    .g-value { font-size: 15px; }
                    .summary-footer { flex-direction: column; align-items: flex-start; padding: 16px 18px; }
                    .footer-divider { display: none; }
                    .details-container { padding: 10px 12px 22px; }
                }
            `}</style>
        </div>
    );
};

const ActionButton = ({ icon, color, label, link, onClick }) => {
    if (onClick) {
        return (
            <button onClick={onClick} className="action-btn-wrapper" style={{ textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
                <span className="btn-label">{label}</span>
            </button>
        );
    }

    return (
        <a href={link || "#"} className="action-btn-wrapper" style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer">
            <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
            <span className="btn-label">{label}</span>
        </a>
    );
};

export default CampaignDetails;